import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteUnidadePessoa(unidadeId: string) {
  return useMutation(
    `/v1/unidades/${unidadeId}/pessoas`,
    (id: string) => http.delete(`/v1/unidades/${unidadeId}/pessoas/${id}`),
    { retry: false }
  );
}

export default useDeleteUnidadePessoa;
